import type { FC, ReactNode } from 'react';

import { Banner, TextLink } from '@zen/DesignSystem';
import { useFeatureIsOn } from '@zen/FeatureFlag';

import { getBannerConfig } from './helpers';
import { usePurchaseOrderTableVersion } from './PurchaseOrderTableVersionContext';
import type { PurchaseOrderTableBannerConfig, PurchaseOrderTableVersion } from './types';

interface Props {
  tableVersion: PurchaseOrderTableVersion;
}

const PurchaseOrderTableBanner: FC<Props> = ({ tableVersion }) => {
  const isNewPurchaseOrderTableEnabled: boolean = useFeatureIsOn('new-po-table');
  const { setTableVersion } = usePurchaseOrderTableVersion();

  if (!isNewPurchaseOrderTableEnabled) {
    return null;
  }

  const { actionLabel, icon, message, targetUrl, targetVersion }: PurchaseOrderTableBannerConfig = getBannerConfig(tableVersion);

  const handleSwitchClick = (): void => {
    setTableVersion(targetVersion);
  };

  const actions: ReactNode = (
    <TextLink color="dark" linkTo={targetUrl} onClick={handleSwitchClick}>
      {actionLabel}
    </TextLink>
  );

  return (
    <div data-component="purchase-order-table-banner">
      <Banner actions={actions} icon={icon} isRounded={false} message={message} type="neutral" />
    </div>
  );
};

export type { Props as PurchaseOrderTableBannerProps };
export default PurchaseOrderTableBanner;
